import { useState, useEffect } from "react";

// Custom hook to determine if an element is intersecting with the viewport
/**
 * observerParams - IntersectionObserver options
 * @param {*} threshold -  Threshold(s) at which to trigger the callback
 * @param {*} root - Root element for intersection checking
 * @param {*} rootMargin - Margin around the root for intersection detection
 */

/**
 * @param {*} elementRef - Reference to the DOM element
 * @param {*} observerParams - IntersectionObserver options
 * @returns isIntersecting -  Whether the element is intersecting with the viewport
 */
export const useIntersectionObserver = (elementRef, observerParams) => {
  const [isIntersecting, setIntersecting] = useState(false);

  const observerCallback = ([entries]) => {
    setIntersecting(entries.isIntersecting);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(observerCallback, observerParams);
    if (elementRef?.current) {
      observer.observe(elementRef?.current);
    }

    return () => observer.disconnect();
  }, [elementRef, observerParams]);

  return isIntersecting;
};
